import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "MailAllMailboxSearch" */ "./lazyIndex"), { name: "MailAllMailboxSearch" });

export const lazyPerformAllMailboxSearch: LazyAction<typeof lazyIndex.performAllMailboxSearch, typeof lazyModule> = new LazyAction(lazyModule, m => m.performAllMailboxSearch);

export const lazyLoadMoreAllMailboxSearch: LazyAction<typeof lazyIndex.loadMoreAllMailboxSearch, typeof lazyModule> = new LazyAction(lazyModule, m => m.loadMoreAllMailboxSearch);
